<template>
  <div
    :class="[
      'faq__item',
      {faq_active: active}
    ]"
  >
    <h3 class="faq__question" @click="(event) => $emit('click', event)">
      {{item.q}}

      <div class="faq__control"></div>
    </h3>

    <div class="faq__answer">
      <p>
        {{item.a}}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExpandPanel",

  props: ["item", "active"],
}
</script>

<style lang="sass" scoped>
@import '../../../sass/variables'

.faq__item
  display: flex
  flex-direction: column
  position: relative
  width: 100%
  margin-bottom: 16px
  background: none
  border-radius: 0
  border-bottom: 1px solid rgba(109, 109, 109, 0.2)

  &:last-child
    margin-bottom: 0

  .faq__control
    width: 32px
    height: 32px
    transition: .4s ease
    //background: url($baseUrl + 'subscription/arrow-down.svg') no-repeat center center / contain
    transform: rotate(0deg)

  &.faq_active
    .faq__control
      transform: rotate(180deg)

  .faq__question
    display: flex
    justify-content: space-between
    align-items: center
    text-align: left
    gap: 16px
    padding: 0 0 16px
    font-size: 20px
    font-weight: 500
    line-height: 30px
    color: rgba(42, 42, 42, 1)
    cursor: pointer

  .faq__answer
    padding: 0
    max-height: 0
    overflow: hidden
    transition: .4s ease
    color: rgba(109, 109, 109, 1)

    p
      text-align: left
      font-weight: 400
      font-size: 16px
      line-height: 22px
      padding: 0 0 16px
</style>
